import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ReportService } from '../../../../../common/services/Report.service';
import { GroupService } from '../../../../../common/services/Group.service';
import { UserService } from '../../../../../common/services/User.service';
import { IvrgatewayService } from '../../../../../common/services/Ivrgateway.service';
import { QueueService } from '../../../../../common/services/Queue.service';
import { CampaignService } from '../../../../../common/services/Campaign.service';
import { ServiceService } from '../../../../../common/services/Service.service';
import { QueueVoiceManager, ReportGroupBy, ReportGroupByArray, SourceArray } from './filter.const';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { Role } from '../../setting/expert/expert.const';

@Component({
  selector: 'app-report-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css'],
  providers: [
    ReportService,
    GroupService,
    UserService,
    IvrgatewayService,
    QueueService,
    CampaignService,
    ServiceService,
  ],
})
export class FilterComponent implements OnInit, OnChanges {
  @Input() multiple = false;
  @Input() agent = false;
  @Input() group = false;
  @Input() caller = false;
  @Input() callid = false;
  @Input() duration = false;
  @Input() connectStatus = false;
  @Input() acdTime = false;
  @Input() groupBys: any;
  @Input() modelFilter: any;

  @Output() onSubmitFilter = new EventEmitter<{ item: any }>();
  @Output() onExport = new EventEmitter<any>();
  @Output() onImport = new EventEmitter<any>();

  public user: any = {};
  public model: any;
  public filterType = 'min';
  public groups: Array<any> = [];
  public agentInGroup: Array<any> = [];
  public agents: Array<any> = [];
  public ivrGateways: Array<any> = [];
  public queues: Array<any> = [];
  public campaigns: Array<any> = [];
  public sources: Array<any> = [];
  public services: Array<any> = [];
  public connectStatusLists: Array<any> = [
    {
      id: 'miss',
      text: 'Bị nhỡ',
    },
    {
      id: 'connected',
      text: 'Trả lời',
    },
  ];

  protected readonly ReportGroupBy = ReportGroupBy;

  constructor(
    private reportService: ReportService,
    private groupService: GroupService,
    private userService: UserService,
    private ivrGatewaysService: IvrgatewayService,
    private queueService: QueueService,
    private serviceService: ServiceService,
    private campaignService: CampaignService
  ) {
    this.user = JSON.parse(localStorage.getItem('User')) || {};
  }

  ngOnInit() {
    this.groupBys = this.groupBys ? this.groupBys : ReportGroupByArray;
    this.sources = SourceArray;
    this.refreshFilter();
    Observable.forkJoin([
      this.getGroups(),
      this.getAllAgents(),
      this.getAllIvrGateway(),
      this.getAllCampaign(),
      this.getAllQueue(),
      this.getAllService(),
    ]).subscribe(data => {});
  }

  getGroups() {
    return this.groupService.allGroup({ target: 'user' }).map(res => {
      if (res.status == 200) {
        const groupList = [];
        groupList.push({
          id: '',
          text: '-- Tất cả --',
        });
        res.data.forEach((c: any) => {
          groupList.push({
            text: c.name,
            id: c.id.toString(),
          });
        });
        this.groups = groupList;
      }
    });
  }
  getAllAgents() {
    return this.userService.all({}).map(res => {
      if (res.status == 200) {
        const agentList = [
          {
            id: '',
            text: '-- Tất cả --',
            email: '',
            group_id: null,
          },
        ];
        res.data.list.forEach((c: any) => {
          agentList.push({
            text: c.name,
            id: c.agent_id,
            email: c.email,
            group_id: c.group_id,
          });
        });
        this.agents = agentList;
        this.agentInGroup = agentList;

        if (this.user.role === Role.TeamLeader) {
          this.agents = this.agents.filter(agent => agent.group_id == this.user.group_id);
        }
      }
    });
  }
  getAllIvrGateway() {
    return this.ivrGatewaysService.list({}).map(res => {
      if (res.status == 200) {
        const ivrGatewaysList = [];
        ivrGatewaysList.push({
          id: '',
          text: '-- Tất cả --',
        });
        res.data.ivrgateways.forEach((c: any) => {
          ivrGatewaysList.push({
            text: c.line,
            id: c.line,
          });
        });
        this.ivrGateways = ivrGatewaysList;
      }
    });
  }
  getAllQueue() {
    return this.queueService.list({}).map(res => {
      if (res.status == 200) {
        const queueList = [];
        queueList.push({
          id: '',
          text: '-- Tất cả --',
        });
        res.data.queues.forEach((c: any) => {
          if (QueueVoiceManager.includes(c.QUEUE_MANAGER_ID)) {
            queueList.push({
              text: c.DESCRIPTION,
              id: c.QUEUE_ID.toString(),
            });
          }
        });
        this.queues = queueList;
      }
    });
  }
  getAllCampaign() {
    return this.campaignService.all({}).map(res => {
      const campaignList = [];
      campaignList.push({
        id: '',
        text: '-- Tất cả --',
      });
      res.data.list.forEach((c: any) => {
        if (c.campaign_type == 'call') {
          campaignList.push({
            text: c.name,
            id: c._id,
          });
        }
      });
      this.campaigns = campaignList;
    });
  }
  getAllService() {
    return this.serviceService.allService().map(res => {
      const serviceList = [];
      serviceList.push({
        id: '',
        text: '-- Tất cả --',
      });
      res.data.forEach((c: any) => {
        if (!c.parent_id) {
          serviceList.push({
            text: c.name,
            id: c.id.toString(),
          });
        }
      });
      this.services = serviceList;
    });
  }
  changeFilterType(type) {
    this.filterType = type;
    if (type == 'min') {
      this.refreshFilter(true);
    }
  }

  public changedSource(e: any): void {
    if (e.value) {
      this.model['source'] = e.value;
    } else {
      this.model['source'] = '';
    }
  }
  public changedGroupBy(e: any): void {
    if (e.value) {
      this.model['groupBy'] = e.value;
    } else {
      this.model['groupBy'] = '';
    }
  }
  public changedGroups(e: any): void {
    if (e.value) {
      this.model['groups'] = e.value;
    } else {
      this.model['groups'] = '';
    }
  }

  public changedConnectStatus(e: any): void {
    if (e.value) {
      this.model['connectStatus'] = e.value;
    } else {
      this.model['connectStatus'] = '';
    }
  }
  public changedAgents(e: any): void {
    if (e.value) {
      this.model['agents'] = e.value;
    } else {
      this.model['agents'] = '';
    }
  }
  public changedCampaigns(e: any): void {
    if (e.value) {
      this.model['campaigns'] = e.value;
    } else {
      this.model['campaigns'] = '';
    }
  }
  public changedCalleds(e: any): void {
    if (e.value) {
      this.model['calleds'] = e.value;
    } else {
      this.model['calleds'] = '';
    }
  }
  public changedQueues(e: any): void {
    if (e.value) {
      this.model['queues'] = e.value;
    } else {
      this.model['queues'] = '';
    }
  }
  public changedCallId(e: any): void {
    console.log(e.target.value);
    if (e.target.value) {
      this.model['callId'] = e.target.value;
    } else {
      this.model['callId'] = '';
    }
  }
  public changedCaller(e: any): void {
    if (e.target.value) {
      this.model['caller'] = e.target.value;
    } else {
      this.model['caller'] = '';
    }
  }
  public changedDuration(e: any): void {
    if (e.target.value) {
      this.model['duration'] = e.target.value;
    } else {
      this.model['duration'] = '';
    }
  }

  public changedAcdTimeGt(e: any): void {
    if (e.target.value) {
      this.model['acdTimeGt'] = e.target.value;
    } else {
      this.model['acdTimeGt'] = '';
    }
  }

  public changedAcdTimeLt(e: any): void {
    if (e.target.value) {
      this.model['acdTimeLt'] = e.target.value;
    } else {
      this.model['acdTimeLt'] = '';
    }
  }

  refreshFilter(refresh?: any) {
    const user = JSON.parse(localStorage.getItem('User'));
    if (!refresh && this.modelFilter) {
      this.model = this.modelFilter;
    } else {
      this.model = {
        from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
        to: moment().format('YYYY-MM-DD HH:mm'),
        source: '-1',
        tenantId: user.tenant_id,
        groups: '',
        caller: '',
        callId: '',
        queues: '',
        calleds: '',
        campaigns: '',
        acdTimeGt: '',
        acdTimeLt: '',
        connectStatus: '',
        agents: '',
        groupBy: this.modelFilter.groupBy || ReportGroupByArray[0].id,
      };
    }
    if (!Array.isArray(this.model.groupBy) && this.model.groupBy) {
      this.model.groupBy = this.model.groupBy.split(',');
    }
    if (!Array.isArray(this.model.groups) && this.model.groups) {
      this.model.groups = this.model.groups.split(',');
    }
    if (!Array.isArray(this.model.queues) && this.model.queues) {
      this.model.queues = this.model.queues.split(',');
    }
    if (!Array.isArray(this.model.calleds) && this.model.calleds) {
      this.model.calleds = this.model.calleds.split(',');
    }
    if (!Array.isArray(this.model.campaigns) && this.model.campaigns) {
      this.model.campaigns = this.model.campaigns.split(',');
    }
    if (!Array.isArray(this.model.agents) && this.model.agents) {
      this.model.agents = this.model.agents.split(',');
    }
  }

  submitFilter() {
    const item = _.assign({}, this.model);
    console.log(item);
    item.groupBy = item.groupBy ? item.groupBy.toString() : '';
    item.queues = item.queues ? item.queues.toString() : '';
    item.campaigns = item.campaigns ? item.campaigns.toString() : '';
    item.calleds = item.calleds ? item.calleds.toString() : '';
    item.agents = item.agents ? item.agents.toString() : '';
    item.groups = item.groups ? item.groups.toString() : '';
    this.onSubmitFilter.emit({ item: item });
  }
  export() {
    this.onExport.emit();
  }
  import() {
    this.onImport.emit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.modelFilter) {
      this.modelFilter = changes.modelFilter.currentValue;
      this.refreshFilter();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/filter/filter.component.ts